/**
 * JavaScript Document
 * Version: 1.0.0
 * Date: 4/21/2020
 * Author: Liu Changkun
 * Copyright: www.east.net
 */
import Vue from "vue";
import eastImg from "./east-img";
import eastOperate from "./east-operate";
import generalLayout from "./general-layout";
import layuiTable from "./layui-table";
import layuiTableColumn from "./layui-table/column";

Vue.component("east-img", eastImg);
Vue.component("east-operate", eastOperate);
Vue.component("general-layout", generalLayout);
Vue.component("layui-table", layuiTable);
Vue.component("layui-table-column", layuiTableColumn);

// const moduleFiles = require.context(".", true, /\.vue$/);
// for (let key of moduleFiles.keys()) {
//   let component = moduleFiles(key).default;
//   Vue.component(component.name, component);
// }
